import { ControlTowerTourModel, DashboardModel, EscalatedToursModel, EscalationHistoryModel } from "@core/services/api.service";

export class LoadControlTowerToursAction {
    static readonly type = '[ControlTowerTours] Load Control Tower Tours';
}

export class LoadControlTowerToursSuccessAction {
    static readonly type = '[ControlTowerTours] Load Control Tower Tours Success';

    constructor(public payload: { tours: ControlTowerTourModel[] }) { }
}

export class LoadControlTowerToursFailAction {
    static readonly type = '[ControlTowerTours] Load Control Tower Tours Fail';
}

export class LoadEscalatedToursAction {
    static readonly type = '[EscalatedTours] Load Escalated Tours Tours';
}

export class LoadEscalatedToursSuccessAction {
    static readonly type = '[EscalatedTours] Load Escalated Tours Tours Success';

    constructor(public payload: { tours: EscalatedToursModel[] }) { }
}

export class LoadEscalatedToursFailAction {
    static readonly type = '[EscalatedTours] Load Escalated Tours Tours Fail';
}

export class LoadControlTowerDashboardsAction {
    static readonly type = '[ControlTowerDashboards] Load Control Tower Dashboards Metrics';
    constructor() { }
  }

  export class LoadControlTowerDashboardsSuccessAction {
    static readonly type = '[ControlTowerDashboards] Load Control Tower Dashboards Success';

    constructor(public payload: { dashboards: DashboardModel[] }) { }
  }

  export class LoadControlTowerDashboardsFailAction {
    static readonly type = '[ControlTowerDashboards] Load Control Tower Dashboards Fail';
  }


export class MarkTourResolvedAction {
    static readonly type = '[ResolvedEscalation] Mark Tour Resolved action';

    constructor(public id: number, public tourId: number) { }
}

export class MarkTourResolvedActionSuccessAction {
    static readonly type = '[ResolvedEscalation] Mark Tour Resolved Success';

    constructor(public payload: { tour: EscalatedToursModel }) { }
}

export class MarkTourResolvedActionFailAction {
    static readonly type = '[ResolvedEscalation] Mark Tour Resolved Fail';
}

export class EscalateTourByIdAction {
    static readonly type = '[EscalateTour] Escalate Tour action';

    constructor(public id: number, public topic: string, public message: string, public isControlRoom: boolean, public priority: number) { }
}

export class EscalateTourByIdSuccessAction {
    static readonly type = '[EscalateTour] Escalate Tour Success';

    constructor(public payload: { tour: EscalatedToursModel }) { }
}

export class EscalateTourByIdFailAction {
    static readonly type = '[EscalateTour] Escalate Tour Fail';
}

export class LoadEscalatedHistoryAction {
    static readonly type = '[EscalatedHistory] Load Escalated History';

    constructor(public id: number, public topic: string) { }
}

export class LoadEscalatedHistorySuccessAction {
    static readonly type = '[EscalatedHistory] Load Escalated History Success';

    constructor(public payload: { history: EscalationHistoryModel[] }) { }
}

export class LoadEscalatedHistoryFailAction {
    static readonly type = '[EscalatedHistory] Load Escalated History Fail';
}

export class AddEscalationHistoryAction {
    static readonly type = '[AddEscalation] Add Escalation History action';

    constructor(public id: number, public message: string, public isControlRoom: boolean, public topic: string) { }
}

export class AddEscalationHistorySuccessAction {
    static readonly type = '[AddEscalation] Add Escalation History Success';

    constructor(public payload: { tour: EscalationHistoryModel }) { }
}

export class AddEscalationHistoryFailAction {
    static readonly type = '[AddEscalation] Add Escalation History Fail';
}

export class RegisterSignalRHandlersForChatAction {
    static readonly type = '[EscalationChat] Register SignalR Handlers For Escalation Chat';
}


export class AddNotification {
    static readonly type = '[Notification] Add';
    constructor(public payload: { message: string; tourId: number }) {}
}

export class RemoveNotification {
    static readonly type = '[Notification] Remove';
    constructor(public tourId: number) {}
}

export interface NotificationStateModel {
    notifications: { message: string; tourId: number }[];
}

export class ChangePriorityAction {
    static readonly type = '[ChangePriority] Change priority action';

    constructor(public id: number, public tourId: number, public priority: string) { }
}

export class ChangePriorityActionSuccessAction {
    static readonly type = '[ChangePriority] Change priority Success';

    constructor(public payload: { tour: EscalatedToursModel }) { }
}

export class ChangePriorityActionFailAction {
    static readonly type = '[ChangePriority] Change priority Fail';
}
